<template>
  <div
    class="skeleton ant-skeleton ant-skeleton-active"
    :style="{
      width: width,
      height: height,
    }"
  />
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '16px',
    },
  },
}
</script>

<style lang="scss">
.skeleton {
  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
  background-size: 400% 100%;
  animation: ant-skeleton-loading 1.4s ease infinite;
}
</style>
